import axios from "axios";
import http, { getTenantFromUrl } from "../helpers/http";
import https from "../helpers/https";

export const getMerchants = async (tenant = getTenantFromUrl()) => {
  const response = await http().get("/Merchant/List");
  return response.data;
};

export const getProspects = async (id, tenant = getTenantFromUrl()) => {
  const response = await http().get(`/Merchant/GetProspects/${id}`);
  return response.data;
};

export const handleProspects = async (payload, tenant = getTenantFromUrl()) => {
  const response = await http().post("/Merchant/HandleProspects", payload);
  return response.data;
};

export const downloadDocument = async (id, tenant = getTenantFromUrl()) => {
  const response = await http().get(`/Document/DownloadDocAdmin?id=${id}`, {
    responseType: "blob",
  });
  return response.data;
};

export const migrateMerchants = async (tenant = getTenantFromUrl()) => {
  const response = await http().get("/Merchant/MigrateUnregisteredMerchants");
  return response.data;
};

export const uploadSla = async (payload, tenant = getTenantFromUrl()) => {
  const response = await https().post("/Merchant/UploadSlaDoc", payload);
  return response.data;
};

export const prospectsDetails = async (id, tenant = getTenantFromUrl()) => {
  const token = localStorage.getItem("token");

  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/Merchant/GetProspect/admin/${id}`,
    {
      headers: {
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const getSingleMerchant = async (id, tenant = getTenantFromUrl()) => {
  const response = await http().get(`/Merchant/Single/${id}`);
  return response.data;
};

export const migrateSingleMerchant = async (id, tenant = getTenantFromUrl()) => {
  const response = await http().get(`/Merchant/MigrateSingleMerchant/${id}`);
  return response.data;
};

export const fetchPaymentScheme = async (tenant = getTenantFromUrl()) => {
  const response = await http().get("/payment-scheme");
  return response.data;
};

export const fetchPaymentMethod = async (tenant = getTenantFromUrl()) => {
  const response = await http().get("/payment-method");
  return response.data;
};

export const initiatePaymentMethod = async (payload, tenant = getTenantFromUrl()) => {
  const response = await http().post("/payment-method/initiate", payload);
  return response.data;
};

export const initiatePaymentScheme = async (payload, tenant = getTenantFromUrl()) => {
  const response = await http().post("/payment-scheme/initiate", payload);
  return response.data;
};

export const deletePaymentScheme = async (payload, tenant = getTenantFromUrl()) => {
  const response = await http().delete("/payment-scheme/initiate", {
    data: payload,
  });
  return response.data;
};

export const deletePaymentMethod = async (payload, tenant = getTenantFromUrl()) => {
  const response = await http().delete("/payment-method/initiate", {
    data: payload,
  });
  return response.data;
};

export const fetchSchemeMerchant = async (id, tenant = getTenantFromUrl()) => {
  const response = await http().get(
    `/payment-scheme/merchant?merchantId=${id}`
  );
  return response.data;
};

export const fetchMethodMerchant = async (id, tenant = getTenantFromUrl()) => {
  const response = await http().get(
    `/payment-method/merchant?merchantId=${id}`
  );
  return response.data;
};

export const fetchConfigRequests = async (pageNumber, pageSize, tenant = getTenantFromUrl()) => {
  const response = await http().get(
    `/authorize?pageNumber=${pageNumber}&pageSize=${pageSize}`
  );
  return response.data;
};

export const handleConfigRequests = async (payload, tenant = getTenantFromUrl()) => {
  const response = await http().post("/authorize", payload);
  return response.data;
};

export const editMerchant = async (id, payload, tenant = getTenantFromUrl()) => {
  const response = await http().post(`/Merchant/EditMerchant/${id}`, payload);
  return response.data;
};

export const fetchMerchantRequests = async (tenant = getTenantFromUrl()) => {
  const response = await http().get(
    "/Merchant/GetMerchantAuthorizationRequest"
  );
  return response.data;
};

export const handleMerchantRequests = async (id, payload, tenant = getTenantFromUrl()) => {
  const response = await http().post(
    `/Merchant/ApproveorDeclineMerchantRequest/${id}`,
    payload
  );
  return response.data;
};

export const getTxpgInfo = async (id, tenant = getTenantFromUrl()) => {
  const response = await http().get(`/Merchant/GetTxpgConfiguration/${id}`);
  return response.data;
};

export const createTxpg = async (payload, tenant = getTenantFromUrl()) => {
  const response = await http().post(
    "/Merchant/EditTxpgConfiguration",
    payload
  );
  return response.data;
};

export const getAllPendingProspects = async (params, tenant = getTenantFromUrl()) => {
  const { Name, Email, PageNumber, PageSize } = params;
  const response = await http().get(
    `/Merchant/GetAllPendingProspects/prospects/pending?Name=${Name || ""}&Email=${Email || ""}&PageNumber=${PageNumber || 1}&PageSize=${PageSize || 10}`
  );
  return response.data;
};

export const submitFeeConfiguration = async (payload) => {
  const response = await http().post("/MerchantChargeConfiguration/SubmitFeeConfiguration", payload);
  return response.data;
};

export const actAsSupportMaker = async (payload) => {
  const response = await http().post("/MerchantChargeConfiguration/ActAsSupportMaker", payload);
  return response.data;
};

export const actAsSupportChecker = async (payload) => {
  const response = await http().post("/MerchantChargeConfiguration/ActAsSupportChecker", payload);
  return response.data;
};

export const getSupportMakerQueue = async () => {
  const response = await http().get("/MerchantChargeConfiguration/SupportMakerQueue");
  return response.data;
};

export const getSupportCheckerQueue = async () => {
  const response = await http().get("/MerchantChargeConfiguration/SupportCheckerQueue");
  return response.data;
};

export const getLiveFeeConfiguration = async (merchantId, scheme) => {
  const response = await http().get(`/MerchantChargeConfiguration/GetFeeConfiguration?merchantId=${merchantId}&scheme=${scheme}`);
  return response.data;
};

export const calculateFeePreview = async (params) => {
  const { merchantId, baseAmount, currencyCode, isCardTransaction, scheme } = params;
  const response = await http().get(`/MerchantChargeConfiguration/CalculateFee?merchantId=${merchantId}&baseAmount=${baseAmount}&currencyCode=${currencyCode}&isCardTransaction=${isCardTransaction}&scheme=${scheme}`);
  return response.data;
};
